import { z } from 'zod';

import {
  CursorPaginationMetaSchema,
  ListSortOrderSchema,
  PaginationSchema,
} from '../../../pagination.js';
import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const KitListSortFieldSchema = z.enum([
  'name',
  'category',
  'componentCount',
  'version',
  'status',
]);
export type KitListSortField = z.infer<typeof KitListSortFieldSchema>;

export const ListKitsQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(2).max(100).optional(),
  ),
  status: CatalogItemStatusSchema.optional(),
  categoryId: z.uuid().optional(),
  sort: KitListSortFieldSchema.optional(),
  order: ListSortOrderSchema.optional(),
});

export const KitListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  sku: z.string().nullable(),
  categoryId: z.uuid().nullable(),
  status: CatalogItemStatusSchema,
  version: z.number().int(),
  compositionMode: z.enum(['FIXED', 'SLOT']),
  componentCount: z.number().int(),
  updatedAt: z.iso.datetime(),
});

export const ListKitsResponseSchema = z.object({
  items: z.array(KitListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListKitsQuery = z.infer<typeof ListKitsQuerySchema>;
export type KitListItem = z.infer<typeof KitListItemSchema>;
export type ListKitsResponse = z.infer<typeof ListKitsResponseSchema>;
